export var FetchType;
(function(FetchType) {
    FetchType["Next"] = 'next';
    FetchType["Previous"] = 'prev';
    FetchType["All"] = 'all';
})(FetchType || (FetchType = {}));
